export class TypeCommande {
    id: number = 0
    nom: string = ""
}